import { parseVersion } from 'dg-web-shared/common/utils/UpdateUtils';
import { RELEASE_ID } from 'dg-web-shared/common/utils/release';

// interval to check for updates in s
const updateCheckInterval = 300 * 1000;

// stores unix ts of last update check
let lastUpdateCheck: number;

export function fireUpdateRequest(): void {
    // query parameter to circumvent browser cache
    fetch(`/?date=${Date.now()}`)
        .then(result => {
            if (!result.ok) return;
            return result.text();
        })
        .then(text => {
            if (!text) return;
            const serverVersion = parseVersion(text);
            if (!RELEASE_ID || !serverVersion) {
                return;
            }

            if (document && document.location && serverVersion !== RELEASE_ID) {
                document.location.href =
                    '/?enforcement-version=' + serverVersion;
            }
        })
        .catch(() => {});
}

export function init(): void {
    lastUpdateCheck = Date.now();

    fireUpdateRequest();

    (function updateCheck(): void {
        requestAnimationFrame(updateCheck);
        if (Date.now() > lastUpdateCheck + updateCheckInterval) {
            lastUpdateCheck = Date.now();

            fireUpdateRequest();
        }
    })();
}
